/* Global Alert/Confirm Modal
------------------------------------------------ */
import PopupManager from  'element-ui/lib/utils/popup/popup-manager';

var confirmModal = function(message, options) {
    var deferred = $.Deferred();

    var defaults = {
        message: '',
        header: '',
        large: false,
        alert: false,
        resolveText: 'Ok',
        rejectText: 'Cancel',
        keyboard: false,
        backdrop: 'static',
        type: 'primary',
    };
    if(typeof message == 'string') {
        defaults.message = message;
    }
    var opts = $.extend(defaults, options);

    var $confirm = $('#global-alert');
    $confirm.css('z-index', PopupManager.nextZIndex());

    if(opts.large) {
        $confirm.find('.modal-dialog').addClass('modal-lg');
    } else {
        $confirm.find('.modal-dialog').removeClass('modal-lg');
    }

    if(opts.alert) {
        $('.js-global-alert__btn-group button:first').hide();
    } else {
        $('.js-global-alert__btn-group button:first').show();
    }

    if(opts.header) {
        $('.js-global-alert__header h4').text(opts.header);
        $('.js-global-alert__header').show();
    } else {
        $('.js-global-alert__header h4').text('');
        $('.js-global-alert__header').hide();
    }

    var $rejectBtn = $('.js-global-alert__cancel');
    var $resolveBtn = $('.js-global-alert__ok');

    $('.js-global-alert__body').html(opts.message);
    $confirm.modal({
        keyboard: opts.keyboard,
        backdrop: opts.backdrop
    })
    $confirm.modal('show');

    $rejectBtn.text(opts.rejectText);
    $resolveBtn.text(opts.resolveText);

    $resolveBtn.removeClass('btn-primary').addClass('btn-' + opts.type);

    // Just hit enter to acknowledge message (mirrors browser default behavior)
    $confirm.on('shown.bs.modal', function() {
        $confirm.focus().unbind("keyup").keyup(function(e){
            var code = e.which; // recommended to use e.which, it's normalized across browsers
            if(code == 13 || code == 32){
                $resolveBtn.click();
            }
        });
    });

    // Delay rejection to allow the "OK" button to resolve the promise
    $confirm.on('hide.bs.modal', function() {
        setTimeout(function() {
            deferred.reject(false);
        }, 0);
    });

    // resolve before it gets rejected in the "dialogclose" event-handler
    $resolveBtn.on('click', function() {
        $confirm.modal('hide');
        deferred.resolve(true);
    });

    return deferred.promise();
};

Window.prototype.confirmModal = confirmModal;
export {
    confirmModal
}
